module.exports = __webpack_public_path__ + "media/images/s2ep2-cindy-f852e29e3c271a8c6dea97d6184d0162.png";